var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-bracelet-price-display"},[_c('div',{staticClass:"c-bracelet-price-display__bracelet-price-container"},[_c('product-price',{attrs:{"price":_vm.modPrice,"compare-at-price":_vm.modCompareAtPrice}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }